/**
* Retrieves the key value pairs for all URL query parameters.
*/
export default function() {
  const variables = window.location.search.substring(1).split('&');

  if (variables[0]) {
    const pairs = {};

    for (let i = 0; i < variables.length; i++) {
      const pair = variables[i].split('=');
      pairs[pair[0]] = pair[1];
    }

    return pairs;
  }
}
